import React from "react";
import { Stack } from "@altimateai/lego";
import { WorkflowType } from "../types";

interface WorkflowTitleProps {
  workflowType: WorkflowType;
  workflowId?: string;
  runId?: string;
  tableauDashboardName?: string;
}

export const WorkflowTitle: React.FC<WorkflowTitleProps> = ({
  workflowType,
  workflowId,
  runId,
  tableauDashboardName,
}) => {
  if (workflowType === WorkflowType.TABLEAU && tableauDashboardName) {
    return (
      <Stack justify="center" gap="md" align="center">
        <div className="fs-5 al-text-brand">{tableauDashboardName}</div>
        {runId && (
          <>
            <div>/</div>
            <div className="fs-5 al-text-light-gray">{runId}</div>
          </>
        )}
      </Stack>
    );
  }
  
  if (workflowType === WorkflowType.CUSTOM) {
    return (
      <Stack justify="center" gap="md" align="center">
        <div className="fs-5 al-text-brand">{workflowId}</div>
        {runId && (
          <>
            <div>/</div>
            <div className="fs-5 al-text-light-gray">{runId}</div>
          </>
        )}
      </Stack>
    );
  }
  
  return null;
};